import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/happycoins.svg';

export default function ModalsHeaderHappycoins() {

  return (
    <div>
      <div className="ModalsHeader blue">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
